import { motion } from "framer-motion";

const industries = [
  { name: "PVC Pipes", code: "IND / 01" },
  { name: "Blown Films", code: "IND / 02" },
  { name: "Garbage & Carry Bags", code: "IND / 03" },
  { name: "Sheet Extrusion", code: "IND / 04" },
  { name: "Chemical Processing", code: "IND / 05" },
];

const Industries = () => {
  return (
    <section
      id="industries"
      className="bg-[#faf9f6] text-[#0A2A1E] py-24 lg:py-40 px-5 lg:px-10"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-12 gap-6 lg:gap-12 mb-16 lg:mb-20 items-end">
          <div className="col-span-12 lg:col-span-7">
            <div className="section-rule overline mb-6">
              Industries — where we ship
            </div>
            <h2 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-[-0.02em]">
              Serving the{" "}
              <span className="font-display-italic">factories</span>
              <br />
              behind Indian industry.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5">
            <p className="text-lg leading-relaxed text-[#1E3B30]">
              From the polymer that lines your water supply to the pigment in
              your neighbour's bucket — our additives sit quietly inside
              hundreds of everyday products across the subcontinent.
            </p>
          </div>
        </div>

        {/* Asymmetric bento grid */}
        <div className="grid grid-cols-12 auto-rows-[110px] md:auto-rows-[140px] gap-3">
          {industries.map((ind, i) => {
            const spans = [
              "col-span-12 md:col-span-7 row-span-2",
              "col-span-6 md:col-span-5 row-span-1",
              "col-span-6 md:col-span-5 row-span-1",
              "col-span-6 md:col-span-6 row-span-1",
              "col-span-6 md:col-span-6 row-span-1",
            ];
            const isAccent = i === 0 || i === 3;
            return (
              <motion.div
                key={ind.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className={`${spans[i]} border p-5 lg:p-7 flex flex-col justify-between group relative overflow-hidden ${
                  isAccent
                    ? "bg-[#0A2A1E] text-[#faf9f6] border-[#0A2A1E]"
                    : "bg-transparent border-[#0A2A1E]/25 hover:bg-[#0A2A1E] hover:text-[#faf9f6] transition-colors duration-500"
                }`}
              >
                <div className="overline opacity-70">{ind.code}</div>
                <div className="font-display text-2xl md:text-3xl lg:text-4xl leading-[1.05]">
                  {ind.name}
                </div>
                {isAccent && (
                  <div className="absolute -bottom-3 -right-3 w-14 h-14 rotate-45 bg-[#C6F035]" />
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
